export const PERMISSIONS = {
  BENEFICIARIES_VIEW: 'BENEFICIARIES_VIEW',
  BENEFICIARIES_EXPORT: 'BENEFICIARIES_EXPORT',
  BENEFICIARIES_MANAGE: 'BENEFICIARIES_MANAGE',

  TRANSACTIONS_VIEW: 'TRANSACTIONS_VIEW',
  TRANSACTIONS_EXPORT: 'TRANSACTIONS_EXPORT',
  TRANSACTIONS_MANAGE: 'TRANSACTIONS_MANAGE',

  SETTLEMENTS_VIEW: 'SETTLEMENTS_VIEW',
  SETTLEMENTS_EXPORT: 'SETTLEMENTS_EXPORT',
  SETTLEMENTS_MANAGE: 'SETTLEMENTS_MANAGE',

  PAYOUTS_VIEW: 'PAYOUTS_VIEW',
  PAYOUTS_EXPORT: 'PAYOUTS_EXPORT',
  PAYOUTS_MANAGE: 'PAYOUTS_MANAGE',

  DISPUTES_VIEW: 'DISPUTES_VIEW',
  DISPUTES_EXPORT: 'DISPUTES_EXPORT',
  DISPUTES_MANAGE: 'DISPUTES_MANAGE',

  BALANCE_VIEW: 'BALANCE_VIEW',

  DEVELOPER_TAB_VIEW: 'DEVELOPER_TAB_VIEW',
  DEVELOPER_TAB_MANAGE: 'DEVELOPER_TAB_MANAGE',

  PAYMENT_LINKS_VIEW: 'PAYMENT_LINKS_VIEW',
  PAYMENT_LINKS_EXPORT: 'PAYMENT_LINKS_EXPORT',
  PAYMENT_LINKS_MANAGE: 'PAYMENT_LINKS_MANAGE',

  SETTINGS_MANAGE: 'SETTINGS_MANAGE',
  TEAMS_MANAGE: 'TEAMS_MANAGE',

  WALLET_CONVERSIONS_VIEW: 'WALLET_CONVERSIONS_VIEW',
  WALLET_CONVERSIONS_MANAGE: 'WALLET_CONVERSIONS_MANAGE',

  ANY: null
};
